/* eslint-disable */
<template>
  <div class="change-pass-page">
    <vue-basic-alert :duration="1000" :closeIn="5000" ref="alert" />

    <div class="change-pass-container">

      <!-- Left: Branding Panel -->
      <div class="branding-panel">
        <div class="branding-content">

          <div class="brand-gov-badge">LG</div>

          <h1 class="brand-title">Password Security</h1>
          <p class="brand-subtitle">Keep your account safe by using a strong, unique password</p>
          <p class="brand-sinhala">ඔබගේ ගිණුමේ ආරක්ෂාව සඳහා ශක්තිමත් මුරපදයක් භාවිත කරන්න</p>

          <div class="tips-list">
            <div class="tip-item">
              <div class="tip-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                </svg>
              </div>
              <div class="tip-text">
                <strong>At least 8 characters</strong>
                <span>Longer passwords are harder to crack</span>
              </div>
            </div>

            <div class="tip-item">
              <div class="tip-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"/>
                </svg>
              </div>
              <div class="tip-text">
                <strong>Special Characters</strong>
                <span>Include ! @ $ % ^ &amp; * (not #)</span>
              </div>
            </div>

            <div class="tip-item">
              <div class="tip-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                </svg>
              </div>
              <div class="tip-text">
                <strong>Never share your password</strong>
                <span>Keep it private and secure</span>
              </div>
            </div>

            <div class="tip-item">
              <div class="tip-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                </svg>
              </div>
              <div class="tip-text">
                <strong>Change Regularly</strong>
                <span>Update your password periodically</span>
              </div>
            </div>
          </div>

        </div>

        <div class="branding-footer">
          <p>Ministry of Public Administration, Home Affairs,<br>Provincial Councils &amp; Local Government</p>
        </div>
      </div>

      <!-- Right: Form Panel -->
      <div class="form-panel">
        <div class="form-inner">

          <!-- Form Header -->
          <div class="form-header">
            <div class="form-header-bar"></div>
            <div>
              <p class="form-breadcrumb">Account Security</p>
              <h2 class="form-title">Change Password</h2>
              <p class="form-subtitle">ඔබගේ මුරපදය වෙනස් කරන්න | Update your account password below</p>
            </div>
          </div>

          <!-- User info chip -->
          <div class="user-chip" v-if="user">
            <div class="user-avatar">{{ user.cus_name ? user.cus_name.charAt(0).toUpperCase() : 'U' }}</div>
            <div class="user-info">
              <span class="user-name">{{ user.cus_name }}</span>
              <span class="user-nic">{{ user.cus_nic }}</span>
            </div>
          </div>

          <form id="changePassForm" @submit="handleSubmit" novalidate autocomplete="off">

            <!-- Current Password -->
            <div class="field-group">
              <label class="field-label" for="uCurPass">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
                </svg>
                Current Password <span class="req">*</span>
              </label>
              <div class="input-wrap">
                <input :type="showCur ? 'text' : 'password'" id="uCurPass" class="field-input pass-input"
                  placeholder="Enter your current password" v-model="curpass"
                  :class="{ filled: curpass }" />
                <div class="input-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                  </svg>
                </div>
                <button type="button" class="eye-btn" @click="showCur = !showCur" tabindex="-1">
                  <svg v-if="!showCur" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                  </svg>
                </button>
              </div>
              <p class="error-mess" v-if="errorObj.curpassErr.length > 0">{{ errorObj.curpassErr[0] }}</p>
            </div>

            <div class="section-divider">
              <span>Set New Password</span>
            </div>

            <!-- New Password -->
            <div class="field-group">
              <label class="field-label" for="uPass">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                </svg>
                New Password <span class="req">*</span>
              </label>
              <div class="input-wrap">
                <input :type="showNew ? 'text' : 'password'" id="uPass" class="field-input pass-input"
                  placeholder="Enter your new password" v-model="pass"
                  :class="{ filled: pass }" />
                <div class="input-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
                  </svg>
                </div>
                <button type="button" class="eye-btn" @click="showNew = !showNew" tabindex="-1">
                  <svg v-if="!showNew" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                  </svg>
                </button>
              </div>
              <!-- Password strength indicator -->
              <div class="strength-bar" v-if="pass">
                <div class="strength-track">
                  <div class="strength-fill" :style="{ width: strengthPercent + '%' }" :class="strengthClass"></div>
                </div>
                <span class="strength-label" :class="strengthClass">{{ strengthLabel }}</span>
              </div>
              <p class="error-mess" v-if="errorObj.passErr.length > 0">{{ errorObj.passErr[0] }}</p>
            </div>

            <!-- Confirm Password -->
            <div class="field-group">
              <label class="field-label" for="uPassConfirm">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                Confirm New Password <span class="req">*</span>
              </label>
              <div class="input-wrap">
                <input :type="showConfirm ? 'text' : 'password'" id="uPassConfirm" class="field-input pass-input"
                  placeholder="Re-enter your new password" v-model="confirm"
                  :class="{ filled: confirm, matched: confirm && confirm === pass, mismatch: confirm && confirm !== pass }" />
                <div class="input-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <button type="button" class="eye-btn" @click="showConfirm = !showConfirm" tabindex="-1">
                  <svg v-if="!showConfirm" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                  </svg>
                </button>
                <!-- Match tick -->
                <div class="match-tick" v-if="confirm && confirm === pass">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/>
                  </svg>
                </div>
              </div>
              <p class="error-mess" v-if="errorObj.confirmErr.length > 0">{{ errorObj.confirmErr[0] }}</p>
            </div>

            <!-- Hint -->
            <div class="pass-hint">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              Password must be at least 8 characters and contain a special character (not #)
            </div>

            <!-- Submit -->
            <div class="form-actions">
              <router-link to="/" @click="scrollToTop()" class="cancel-btn">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
                </svg>
                Cancel
              </router-link>
              <button type="submit" class="submit-btn">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
                </svg>
                Update Password
              </button>
            </div>

          </form>

          <div class="panel-footer">
            <p>&copy; {{ new Date().getFullYear() }} Local Government Payment System. All rights reserved.</p>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>


<script>
import axios from 'axios';
import VueBasicAlert from 'vue-basic-alert';
import { mapState, mapMutations } from "vuex";

export default {
  name: "ChangePassword",
  components: { VueBasicAlert },
  data() {
    return {
      pass: "", confirm: "", curpass: "",
      showCur: false, showNew: false, showConfirm: false,
      errorObj: { passErr: [], confirmErr: [], curpassErr: [] },
      matchUser: undefined,
      getpassmatch: undefined,
      Nic: '',
    };
  },
  computed: {
    ...mapState(["user"]),
    strengthPercent() {
      if (!this.pass) return 0;
      let score = 0;
      if (this.pass.length >= 8) score += 25;
      if (this.pass.length >= 12) score += 25;
      if (/[!@#$%^&*]/.test(this.pass)) score += 25;
      if (/[A-Z]/.test(this.pass) && /[0-9]/.test(this.pass)) score += 25;
      return score;
    },
    strengthLabel() {
      const p = this.strengthPercent;
      if (p <= 25) return 'Weak';
      if (p <= 50) return 'Fair';
      if (p <= 75) return 'Good';
      return 'Strong';
    },
    strengthClass() {
      const p = this.strengthPercent;
      if (p <= 25) return 'weak';
      if (p <= 50) return 'fair';
      if (p <= 75) return 'good';
      return 'strong';
    },
  },
  created() { this.getSessionData(); },
  methods: {
    ...mapMutations(["setUser"]),

    async MatchUser(nic) {
      let data = await axios.get('/customersdata/' + nic);
      this.matchUser = data.data;
    },

    async getSessionData() {
      const data = JSON.parse(sessionStorage.getItem('Userdata'));
      if (data) { this.Nic = data.Unic; }
      await this.MatchUser(this.Nic);
      this.setUser(this.matchUser);
    },

    async passMatch(id, pass) {
      let data = await axios.get('/customerspass/' + id + '/' + pass);
      this.getpassmatch = data.data;
    },

    scrollToTop() { window.scrollTo(0, 0); },

    resetCheckErr() {
      this.errorObj.passErr = []; this.errorObj.confirmErr = []; this.errorObj.curpassErr = [];
    },

    checkEmptyErr() {
      for (var t in this.errorObj) { if (this.errorObj[t].length !== 0) return false; }
      return true;
    },

    checkForm() {
      this.resetCheckErr();
      if (!this.curpass) this.errorObj.curpassErr.push('Current password is required');
      if (!this.pass) { this.errorObj.passErr.push('New password is required'); }
      else {
        if (!/[!@$%^&*]/.test(this.pass)) this.errorObj.passErr.push('Password must contain at least 1 special character');
        if (this.pass.length < 8) this.errorObj.passErr.push('Password must be at least 8 characters');
      }
      if (!this.confirm) this.errorObj.confirmErr.push('Please confirm your new password');
      else if (this.pass !== this.confirm) this.errorObj.confirmErr.push('Passwords do not match');
    },

    async handleSubmit(e) {
      this.checkForm();
      if (!this.checkEmptyErr()) { e.preventDefault(); }
      else {
        e.preventDefault();
        await this.passMatch(this.Nic, this.curpass);
        if (!this.getpassmatch) {
          this.errorObj.curpassErr.push("Incorrect current password!");
        } else {
          await axios.put("/passUpdate/" + this.Nic, { cus_password: this.pass });
          this.$refs.alert.showAlert('success', 'Your Password has been Updated!');
          this.setUser("");
          window.sessionStorage.clear();
          window.sessionStorage.removeItem('User');
          this.$router.push("/login");
        }
      }
    },
  },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; margin: 0; padding: 0; }

/* ── Page ── */
.change-pass-page {
  /* min-height: 100vh; */
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem 1.5rem;
}

/* ── Split Container ── */
.change-pass-container {
  display: grid;
  grid-template-columns: 38% 62%;
  width: 100%;
  max-width: 950px;
  background: #fff;
  border-radius: 1.4rem;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(100,50,30,0.12);
  border: 1px solid #e5ddd5;
}

/* ── Branding Panel ── */
.branding-panel {
  background: linear-gradient(160deg, #7c2d12 0%, #9a3412 50%, #c2440a 100%);
  padding: 2.2rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}
.branding-panel::before {
  content: '';
  position: absolute; top: -20%; right: -30%;
  width: 30rem; height: 30rem; border-radius: 50%;
  background: rgba(255,255,255,0.05); pointer-events: none;
}
.branding-panel::after {
  content: '';
  position: absolute; bottom: -15%; left: -20%;
  width: 22rem; height: 22rem; border-radius: 50%;
  background: rgba(0,0,0,0.07); pointer-events: none;
}
.branding-content { position: relative; z-index: 1; }

.brand-gov-badge {
  width: 4rem; height: 4rem; border-radius: 0.8rem;
  background: rgba(255,255,255,0.15); border: 2px solid rgba(255,255,255,0.25);
  display: flex; align-items: center; justify-content: center;
  font-family: 'DM Serif Display', serif; font-size: 1.5rem; font-weight: 700; color: #fff;
  margin-bottom: 1rem;
}
.brand-title    { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #fff; line-height: 1.2; margin-bottom: 0.4rem; }
.brand-subtitle { font-size: 1.2rem; color: rgba(255,255,255,0.85); margin-bottom: 0.3rem; line-height: 1.5; }
.brand-sinhala  { font-size: 1.05rem; color: rgba(255,255,255,0.65); margin-bottom: 1.8rem; line-height: 1.5; }

.tips-list { display: flex; flex-direction: column; gap: 0.7rem; }
.tip-item {
  display: flex; align-items: flex-start; gap: 0.9rem;
  padding: 0.8rem 1rem;
  background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.13);
  border-radius: 0.7rem; transition: all 0.2s;
}
.tip-item:hover { background: rgba(255,255,255,0.14); transform: translateX(4px); }
.tip-icon { width: 1.9rem; height: 1.9rem; flex-shrink: 0; }
.tip-icon svg { width: 100%; height: 100%; stroke: rgba(255,255,255,0.9); }
.tip-text { display: flex; flex-direction: column; gap: 0.05rem; }
.tip-text strong { font-size: 1.2rem; font-weight: 600; color: #fff; }
.tip-text span   { font-size: 1.05rem; color: rgba(255,255,255,0.7); }

.branding-footer {
  position: relative; z-index: 1;
  border-top: 1px solid rgba(255,255,255,0.15);
  padding-top: 0.9rem; margin-top: 0.9rem;
}
.branding-footer p { font-size: 1rem; color: rgba(255,255,255,0.6); line-height: 1.5; }

/* ── Form Panel ── */
.form-panel { padding: 1.8rem 2.6rem; display: flex; flex-direction: column; }
.form-inner { display: flex; flex-direction: column; flex: 1; }

/* ── Form Header ── */
.form-header {
  display: flex; align-items: flex-start; gap: 1rem;
  margin-bottom: 1.4rem;
}
.form-header-bar {
  width: 4px; min-height: 52px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 3px;
}
.form-breadcrumb { font-size: 1rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.15rem; }
.form-title    { font-family: 'DM Serif Display', serif; font-size: 2rem; color: #1c0f0a; margin: 0 0 0.15rem; }
.form-subtitle { font-size: 1.15rem; color: #9a8070; margin: 0; }

/* ── User Chip ── */
.user-chip {
  display: flex; align-items: center; gap: 0.9rem;
  background: #faf8f6; border: 1px solid #e5ddd5;
  border-radius: 0.8rem; padding: 0.75rem 1.1rem;
  margin-bottom: 1.6rem;
}
.user-avatar {
  width: 3.2rem; height: 3.2rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; font-family: 'DM Serif Display', serif;
  font-size: 1.4rem; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.user-info { display: flex; flex-direction: column; gap: 0.1rem; }
.user-name { font-size: 1.3rem; font-weight: 600; color: #1c0f0a; }
.user-nic  { font-size: 1.1rem; color: #9a8070; }

/* ── Fields ── */
.field-group { margin-bottom: 1.2rem; }
.field-label {
  display: flex; align-items: center; gap: 0.5rem;
  font-size: 1.2rem; font-weight: 600; color: #4a3028; margin-bottom: 0.45rem;
}
.field-label svg { width: 1.4rem; height: 1.4rem; stroke: #c2440a; flex-shrink: 0; }
.req { color: #c2440a; }

.input-wrap { position: relative; }

.field-input {
  width: 100%;
  padding: 0.65rem 1rem 0.65rem 3.1rem;
  font-size: 1.3rem; font-family: 'DM Sans', sans-serif;
  color: #1c0f0a; background: #faf8f6;
  border: 2px solid #e5ddd5; border-radius: 0.7rem;
  transition: all 0.2s;
}
.field-input:focus {
  outline: none; border-color: #c2440a;
  background: #fff; box-shadow: 0 0 0 3px rgba(194,68,10,0.09);
}
.field-input.filled { background: #fff; border-color: #c2440a; }
.field-input.matched { border-color: #16a34a; box-shadow: 0 0 0 3px rgba(22,163,74,0.1); }
.field-input.mismatch { border-color: #dc2626; }
.field-input::placeholder { color: #b0a09a; }

.input-icon {
  position: absolute; left: 0.9rem; top: 50%; transform: translateY(-50%);
  width: 1.5rem; height: 1.5rem; color: #9a8070; pointer-events: none;
}
.input-icon svg { width: 100%; height: 100%; }

.pass-input { padding-right: 3.2rem; }
.eye-btn {
  position: absolute; right: 0.7rem; top: 50%; transform: translateY(-50%);
  width: 1.8rem; height: 1.8rem;
  background: none; border: none; cursor: pointer;
  color: #9a8070; padding: 0.15rem; border-radius: 0.4rem; transition: all 0.2s;
}
.eye-btn svg { width: 100%; height: 100%; }
.eye-btn:hover { color: #c2440a; background: rgba(194,68,10,0.08); }

/* Match tick */
.match-tick {
  position: absolute; right: 2.8rem; top: 50%; transform: translateY(-50%);
  width: 1.6rem; height: 1.6rem; color: #16a34a;
}
.match-tick svg { width: 100%; height: 100%; }

/* ── Strength Bar ── */
.strength-bar {
  display: flex; align-items: center; gap: 0.8rem;
  margin-top: 0.5rem;
}
.strength-track {
  flex: 1; height: 4px; background: #e5ddd5; border-radius: 99px; overflow: hidden;
}
.strength-fill {
  height: 100%; border-radius: 99px; transition: width 0.3s, background 0.3s;
}
.strength-fill.weak   { background: #dc2626; }
.strength-fill.fair   { background: #f97316; }
.strength-fill.good   { background: #eab308; }
.strength-fill.strong { background: #16a34a; }
.strength-label { font-size: 1.1rem; font-weight: 600; min-width: 4rem; }
.strength-label.weak   { color: #dc2626; }
.strength-label.fair   { color: #f97316; }
.strength-label.good   { color: #eab308; }
.strength-label.strong { color: #16a34a; }

/* ── Section Divider ── */
.section-divider {
  display: flex; align-items: center; gap: 1rem;
  font-size: 1.15rem; font-weight: 600; color: #7c2d12;
  text-transform: uppercase; letter-spacing: 0.06em;
  margin: 0.6rem 0 1.2rem;
}
.section-divider::before, .section-divider::after {
  content: ''; flex: 1; height: 1px; background: #f0e6de;
}

/* ── Hint ── */
.pass-hint {
  display: flex; align-items: flex-start; gap: 0.5rem;
  font-size: 1.15rem; color: #9a8070;
  background: #faf8f6; border: 1px solid #e5ddd5;
  border-radius: 0.6rem; padding: 0.6rem 0.9rem;
  margin-bottom: 1.4rem; line-height: 1.5;
}
.pass-hint svg { width: 1.4rem; height: 1.4rem; stroke: #c2440a; flex-shrink: 0; margin-top: 0.1rem; }

/* Error */
.error-mess { font-size: 1.15rem; color: #b91c1c; margin: 0.3rem 0 0; }
.error-mess::before { content: '⚠ '; }

/* ── Actions ── */
.form-actions {
  display: flex; align-items: center; justify-content: space-between;
  gap: 1rem; flex-wrap: wrap;
  padding-top: 0.4rem;
}

.cancel-btn {
  display: inline-flex; align-items: center; gap: 0.6rem;
  padding: 0.85rem 1.8rem;
  border: 1.5px solid #e5ddd5; background: #fff;
  color: #7a6258; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.35rem; font-weight: 500;
  text-decoration: none; transition: all 0.2s;
}
.cancel-btn svg { width: 1.5rem; height: 1.5rem; }
.cancel-btn:hover { border-color: #c2440a; color: #c2440a; }

.submit-btn {
  display: inline-flex; align-items: center; gap: 0.7rem;
  padding: 0.85rem 2.4rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.4rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 16px rgba(124,45,18,0.28);
  transition: all 0.2s;
}
.submit-btn svg { width: 1.7rem; height: 1.7rem; }
.submit-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,45,18,0.38); }

/* Panel Footer */
.panel-footer {
  margin-top: 1.5rem; padding-top: 0.9rem;
  border-top: 1px solid #f0ebe3; text-align: center;
}
.panel-footer p { font-size: 1.05rem; color: #9a8070; }

/* ── Responsive ── */
@media (max-width: 860px) {
  .change-pass-container { grid-template-columns: 1fr; max-width: 480px; }
  .branding-panel { display: none; }
  .form-panel { padding: 2rem 2rem; }
}
@media (max-width: 520px) {
  .change-pass-page { padding: 0.5rem; }
  .form-panel { padding: 1.5rem 1.2rem; }
  .form-actions { flex-direction: column; }
  .cancel-btn, .submit-btn { width: 100%; justify-content: center; }
}
</style>